<template>
	<phi-page :loading="app.api.isLoading" color="#f3f3f3">
		<div slot="toolbar">
			<mu-icon-button @click="$router.go(-1)" icon="arrow_back" />
			<!-- <h1 v-text="isArchive ? $t('noun.archived.plural') : ( isTrash ? $t('noun.trash') : filter.type)"></h1> -->
			<h1>
				<select class="type-picker" v-model="filter.type" @change="reload()">
					<option v-for="type in types" :value="type.singular" :key="type.singular">{{ type.plural }}</option>
					<option :value="null">{{ $t('post.noun.everything') }}</option>
				</select>

                <select class="message-picker" v-model="filter.filter" @change="reload()">
                    <option :value="null">{{ $t('post.noun.everything') }}</option>
                    <option :value="'read'">{{ $t('adj.read.plural') }}</option>
                    <option :value="'unread'">{{ $t('adj.unread.plural') }}</option>
                </select>
			</h1>

			<!-- quick restore button -->
			<button
				v-if="isArchive || isTrash"
				v-show="feed.count('selected') > 0"
				class="selection-count"
				@click="move('feed')"
			>
				<span v-text="feed.count('selected')"></span>
				<mu-icon value="inbox" />
			</button>

			<!-- quick archive button -->
			<button
				v-else
				v-show="feed.count('selected') > 0"
				class="selection-count"
				@click="move('archive')"
			>
				<span v-text="feed.count('selected')"></span>
				<mu-icon value="archive" />
			</button>

			<mu-icon-menu icon="more_vert">
				<label v-text="$t('action.select')" class="menu-label"></label>
				<mu-menu-item :title="$t('noun.all.plural')" @click="select('all')" />
				<mu-menu-item :title="$t('adj.read.plural')" @click="select('read')" />
				<mu-menu-item :title="$t('adj.unread.plural')" @click="select('unread')" />
				<mu-menu-item :title="$t('noun.none')" @click="select('none')" />

				<mu-divider />

				<mu-menu-item :title="$t('action.archive')" @click="move('archive')" :disabled="!feed.count('selected')" v-if="!isArchive" />
				<mu-menu-item :title="$t('action.restore')" @click="move('feed')" :disabled="!feed.count('selected')" v-if="isArchive" />
				<mu-menu-item :title="$t('action.markRead')" @click="move('read')" :disabled="!feed.count('selected')" />
				<mu-menu-item :title="$t('action.markUnread')" @click="move('unread')" :disabled="!feed.count('selected')" />
				<mu-menu-item :title="$t('action.delete')" @click="move('trash')" :disabled="!feed.count('selected')"  v-if="!isTrash" />
			</mu-icon-menu>
		</div>

		<!-- <post-filters
			v-model="filter"
			:types="types"
			@change="reload()"
		/> -->

		<div>
			<div class="empty" v-show="feed.isEmpty">
				<p>{{ $t('notice.thereIsNothingHere') }}</p>
			</div>

			<section class="phi-card phi-z-0">
				<post-li v-for="post in feed.items"
					:key="post.id"
					:value="post"

					:selected="feed.hasTag(post, 'selected')"
					@toggle="feed.toggleTag(post, 'selected')"
					@click="goToPost(post)"
				/>
				<mu-infinite-scroll v-if="$el && !feed.isEmpty" :scroller="$el.querySelector('.phi-page-body')" :loading="feed.isLoading" @load="feed.hasNext && feed.next()" :loading-text="$t('notice.loading')" />
			</section>
		</div>

		<mu-snackbar v-if="tpl.toastIsShown && lastAction" :message="lastAction.text" :action="$t('action.undo')" @action-click="undo()" @close="tpl.toastIsShown = false" />

	</phi-page>
</template>

<script>
import app from '../../store/app.js';

import PhiPostListItem from '../../components/Phi/Post/ListItem.vue';
import PhiPostFilters from '../../components/Phi/Post/Filters.vue';

export default {
	components: {
		'post-li': PhiPostListItem,
		'post-filters': PhiPostFilters,
	},

	props: {
		personId: {
			default() {
				return app.user.id;
			}
		},

		endpoint: {
			default: 'feed'
		}
	},

	data() {
		return {
			app,
			feed: app.api.collection(`/people/${this.personId}/threads/feed`),

			filter: {
                type: null,
                q: null,
                filter: null,
				creationDate: null
			},

			isArchive: false,
			isTrash: false,
			lastAction: null,
			tpl: {
				menuIsOpen: false,
				toolbarIsHidden: false,
				toastIsShown: false
			},
			types: [],
			searchTimeout: null,
			blockIcons: {
                files: "attachment",
                form: "assignment",
                html: "text_format",
                youtube: "movie"
            }
		}
	},

	beforeRouteEnter(to, from, next) {
		/*
		!!!
		We need to access "to"'s PROPS as defined in the router,
		but this guard doesn't include to.props (shouldn't it?!),
		anyway, they are available somewhere in to.matched.  Hack them out:
		*/
		var props = {};
		for (var i = 0; i < to.matched.length; i++)
        {
			if (to.matched[i].name == to.name) {
				props = to.matched[i].props.default ? to.matched[i].props.default : {};
				break;
			}
		}

		var personId    = props.personId ? props.personId : app.user.id;
		var endpoint    = props.endpoint ? props.endpoint : 'feed';
		var typesFilter = endpoint == 'archive' ? {archive: 1}: (endpoint == 'trash' ? {trash: 1}: {});

		app.api
			.get(`/people/${personId}/threads/types`, typesFilter)
			.then(types => {
                var type   = to.query.type ? to.query.type : null;
                var filter = to.query.filter ? to.query.filter : null;
                var feed   = app.api.collection(`/people/${personId}/threads/${endpoint}`);
				feed.fetch({type: type, filter: filter})
					.then(() => next(vm => {
                        vm.types         = types;
                        vm.filter.type   = type;
                        vm.filter.filter = filter;

                        vm.feed          = feed;
                        vm.isArchive     = endpoint == 'archive';
                        vm.isTrash       = endpoint == 'trash';
					}));
			});
	},

    watch: {
		"filter.type"() {
			let query = this.filter.type ? {type: this.filter.type} : null;
			this.$router.replace({name: this.$route.name, endpoint: this.endpoint, query});
		},

		"filter.filter"() {
			let query = {
				type: this.filter.type,
				filter: this.filter.filter ? this.filter.filter : undefined
			};
			this.$router.replace({name: this.$route.name, endpoint: this.endpoint, query});
		},

        "$route.query.type"(newValue) {
			if (newValue === undefined) {
				return;
			}
			this.filter.type = newValue;
			this.reload();
		},

        "$route.query.filter"(newValue) {
            if (newValue === undefined) {
                return;
            }
            this.filter.filter = newValue;
			this.reload();
        },

		lastAction(action) {
			if (!action) {
				this.tpl.toastIsShown = false;
				return;
			}
			this.tpl.toastIsShown = true;
			setTimeout(() => this.tpl.toastIsShown = false, 3000);
		}
    },

	methods: {
		reload() {
			return this.feed.fetch(this.filter);
		},

		goToPost(post) {
			/* Leaving to read post.  Override cache */
			if (!post.stub.readDate) {
				post.stub.readDate = Math.floor(Date.now() / 1000);
				this.feed.override();

				// override the cached dashboard count as well
				var dashboard = app.api.collection(`/people/${this.personId}/threads/types`);
				dashboard.fetch()
					.then(() => {
						dashboard._items.forEach(type => {
							if (type.singular == post.type) {
								type.unread = Math.max(parseInt(type.unread) - 1, 0);
							}
						});
						dashboard.override();
					});
			}

			this.$router.push({name: 'thread', params:{threadId: post.thread.thread}});
		},

		isUnread(post) {
			// return post.thread.nUnread > 0;
			return !post.stub.readDate;
		},

		select(query) {
			if (query == "all") {
				this.feed.tag(this.feed.items, "selected");
				return;
			}

			this.feed.untag(this.feed.items, "selected");
			if (query == "none") {
				return;
			}

			this.feed.items.forEach(post => {
				switch (query) {
					case "read":
						if (post.stub.readDate) {
							this.feed.tag(post, "selected");
						}
					break;

					case "unread":
						if (!post.stub.readDate) {
							this.feed.tag(post, "selected");
						}
					break;

					default:
						if (post.thread.thread == query) {
							this.feed.tag(post, "selected");
						}
					break;
				}
			});
		},

		move(target) {
			var selection = this.feed.tagged("selected");
			if (!selection.length) {
				return;
			}

			var threadIds = selection.map(post => post.thread.thread);

			app.api
				.post(`/people/${this.personId}/threads/${target}`, threadIds)
				.then(() => {
					if (target != "read" && target != "unread") {
						this.feed.hide(selection);
					} else {
						this.feed.untag(selection, "selected");
						selection.forEach(post => {
							post.stub.readDate = target == "unread" ? null : 111;
						});
					}

					this.lastAction = {
						target,
						selection,
						threadIds,
						text: this.redact(target, threadIds.length)
					};
				});
		},

		undo() {
			if (!this.lastAction) {
				return;
			}

			var target;
			switch (this.lastAction.target) {
				case "read":
					target = "unread";
					break;

				case "unread":
					target = "read";
					break;

				case "feed":
					target = "archive";
					break;

				case "archive":
				case "trash":
					target = "feed";
					break;
			}

			var targetUrl = `/people/${this.personId}/threads/${target}`;

			return app.api.post(targetUrl, this.lastAction.threadIds)
				.then(response => {

					if (target != "read" && target != "unread") {
						this.feed.show(this.lastAction.selection);
					} else {
						this.feed.tag(this.lastAction.selection, "selected");
						this.lastAction.selection.forEach(thread => {
							thread.stub.readDate = target == "unread" ? null : 123;
						});
					}

					this.lastAction = null;

					return response;
				});
		},

		redact(target, count) {
			var plural    = count > 1;
			var redaction = count + ' ';
			switch (target) {
				case 'feed':
					redaction = redaction + (plural ? 'restaurados' : 'restaurado');
				break;
				case 'archive':
					redaction = redaction + (plural ? 'archivados' : 'archivado');
				break;
				case 'trash':
					redaction = redaction + (plural ? 'eliminados' : 'eliminado');
				break;
				case 'read':
					redaction = redaction + (plural ? 'marcados como leído' : 'marcado como leído');
				break;
				case 'unread':
					redaction = redaction + (plural ? 'marcados como no leído' : 'marcado como no leído');
				break;
			}

			return redaction;
		}
	}
}
</script>

<style scoped lang="scss">
    .menu-label {
    	display: block;
    	margin: 0;
    	padding: 0 9px;
    	font-size: 14px;
    	color: #999;
    }

    .type-picker {
    	border: none;
    	background: transparent;
    	font-size: 1em;
        width: 110px;
    }

    .message-picker {
        border: none;
        background: transparent;
        font-size: 1em;
    }

    .loadNext {
    	display: block;
    	width: 100%;
    	padding: 12px;
    	margin: 12px 0;
    	background: rgba(0, 0, 0, 0.1);
    	color: #333;
    	border: 0;
    	cursor: pointer;
    }

    .empty {
    	text-align: center;
    	padding-top: 96px;
    	background: url('../../assets/cactus.png') no-repeat top center;
    	margin-top: 64px;

    	p {
    		font-size: 1.2em;
    		margin: 12px 0;
    		color: #666;
    	}
    }

    .phi-menu li {
    	white-space: nowrap;
    }

    .selection-count {
    	width: auto;
    	display: flex;
    	align-items: center;

    	span {
    		font-size: 0.8em;
    		margin-right: .5em;
    	}
    }
</style>